<template>
  <div class="earth-3d-container">
    <div class="earthMap">
      <!--      <Teleport to="body">-->
      <div v-show="activeWordMap && !loadingState" id="earthMap" ref="earthRef"></div>
      <div v-show="!activeWordMap && !loadingState" id="wordMap" ref="wordRef"></div>
      <!--      </Teleport>-->
      <div class="earthMapBtn-container" :style="btnStyle">
        <!--        <div class="videoOpen" @click="videoOpen">视频监控</div>-->
        <div class="wordMapBox" style="margin-top: 10px;">
          <div
              style="margin-bottom: 10px"
              :class="{
									activeWordMap: activeWordMap,
									wordMap: !activeWordMap,
								}"
              @click="checkMapState(true)"
          >
            3D地图
          </div>
          <div
              :class="{
									activeWordMap: !activeWordMap,
									wordMap: activeWordMap,
								}"
              @click="checkMapState(false)"
          >
            世界地图
          </div>
        </div>
      </div>
      <loading :text="'正在加载地图'" :loadingState="loadingState"></loading>
      <div class="rainBox" :style="rainStyle">
        <canvas class="rain" width="1186" height="731"></canvas>
        <canvas class="rain2" width="1186" height="731"></canvas>
        <canvas class="rain3" width="1186" height="731"></canvas>
      </div>
    </div>
  </div>
</template>
<script setup>
import wordData from "./assets/world.json"
import {nextTick, onMounted, ref, watchEffect, watch} from "vue";
import {useDebounceFn, useEventListener} from "@vueuse/core";
import bg1 from './assets/earth.jpg'
import bg2 from './assets/earthHB.jpg'
import Loading from './loading.vue'
import util from "@/option/common/util";

const props = defineProps({
  thisArg: {},
  option: {},
  prop: {},
  isDataCenter: {},
  dataChart: {}
})
const loadingState = ref(false)
const earthRef = ref()
const wordRef = ref()
let earthChart;
const activeWordMap = ref(true)
const dangerList = ref([])
let updateChart = useDebounceFn(() => {
  if (!props.dataChart?.length) return;
  if (activeWordMap.value) {
    earthEcharts()
  } else {
    wordEcharts()
  }
  setTimeout(() => {
    earthChart?.setOption({
      globe: {
        // viewControl: {
        //   autoRotate: false, // 鼠标悬浮时停止旋转
        // },
      },
    });
  }, 100)
}, 500)
const regions = computed(() => {
  let list = []
  dangerList.value.forEach((item) => {
    let color = ''
    if (item.dangerRank == 3) {
      color = "#fd0001";
    } else if (item.dangerRank == 2) {
      color = "#f75e02";
    } else if (item.dangerRank == 1) {
      color = "#feca02";
    }
    list.push({
      name: item.country,
      itemStyle: {
        normal: {
          areaColor: color,
        },
      },
    });
  });
  return list;
})
const btnStyle = computed(() => {
  return {
    left: props.option.btnX + 'px',
    top: props.option.btnY + 'px',
  };
})
const rainStyle = computed(() => {
  return {
    left: props.option.rainX + 'px',
    top: props.option.rainY + 'px',
  };
})

watchEffect(() => {
  if (props.option.dangerCountry) {
    getDangerData()
  } else {
    dangerList.value = []
    if (!activeWordMap.value) {
      updateChart()
    }
  }
})

function getDangerData() {
  util.lowCodeRequest({
    data: {
      "type": "dataCount",
      "modelSource": "folder",
      "dataModelId": "dataset_ca87cde9f5d2a43e5a02fbeac22c2908",
      "paramMap": {
        "modelVersionNum": 1,
        "_sort_set": {},
        "dimensions": [
          {
            "code": "f_ba7424a4185090fb",
            "fieldType": "String",
            "type": "default",
            "_fieldSet": {
              "basicConfig": {
                "orderWay": {
                  "code": "noOrder",
                  "customOrder": []
                }
              },
              "showFormat": {
                "isDictName": false
              },
              "dateOffset": {},
              "highCount": {
                "dateOffset": {}
              },
              "indexConfig": {
                "assistIndexs": []
              },
              "filterDatas": {}
            }
          }
        ],
        "kpis": [
          {
            "type": "main",
            "code": "f_05b60e4221980230",
            "fieldType": "String",
            "_fieldSet": {
              "basicConfig": {
                "orderWay": {
                  "code": "noOrder",
                  "customOrder": []
                }
              },
              "showFormat": {
                "isDictName": false
              },
              "dateOffset": {},
              "highCount": {
                "dateOffset": {}
              },
              "indexConfig": {
                "assistIndexs": []
              },
              "filterDatas": {}
            }
          }
        ],
        "filterDatas": {},
        "guides": [],
        "_appId": "defaultappid",
        "_version": "1.0.0",
        "_pageId": "100101250320090537705406"
      },
      "__flag": true,
      "name": "地图风险区域",
      "valueCode": "NEW_STRUCTURE"
    }
  }, false).then((res) => {
    if (!Array.isArray(res)) return;
    dangerList.value = res.map((item) => {
      return {
        country: item.f_ba7424a4185090fb,
        dangerRank: item.f_05b60e4221980230
      }
    })
    if (!activeWordMap.value) {
      updateChart()
    }
  })
}

const prjNameCode = computed(() => {
  if (!props?.prop?.dimensions?.length) return;
  return props?.prop?.dimensions[0].code;
})
const chineseCode = computed(() => {
  if (!props?.prop?.metrics?.length) return;
  return props?.prop?.metrics.find(el => el.name === '中方人数')?.code;
})
const foreignCode = computed(() => {
  if (!props?.prop?.metrics?.length) return;
  return props?.prop?.metrics.find(el => el.name === '外籍人数')?.code;
})
const longitudeCode = computed(() => {
  if (!props?.prop?.metricsL?.length) return;
  return props?.prop?.metricsL[0].code;
})
const latitudeCode = computed(() => {
  if (!props?.prop?.metricsR?.length) return;
  return props?.prop?.metricsR[0].code;
})
const defaultD = {
  prjValue: [
    {
      "foreignNationalsNum": 0,
      "latitude": "38.027412",
      "prj_name": "苏州中材宁夏青铜峡日产4000吨二代新型干法节能环保绿色智能示范项目EPC总承包项目",
      "longitude": "106.085371",
      "chinesePersonnelNum": 20
    },
    {
      "foreignNationalsNum": 0,
      "latitude": "30.633338",
      "prj_name": "苏州中材池州中建材新材料有限公司贵池区矿产品运输廊道建设项目工程总承包项目",
      "longitude": "117.875293",
      "chinesePersonnelNum": 643
    },
    {
      "foreignNationalsNum": 0,
      "latitude": "29.568996",
      "prj_name": "成都智科中材渝建（重庆）节能新材料有限公司硅酸钙板生产线生产数字化管控平台项目",
      "longitude": "106.558437",
      "chinesePersonnelNum": 276
    },
  ],
  danger: [
    {
      "country": "俄罗斯",
      "dangerRank": 3
    }
  ]
}
const earthData = ref([])

const linesList = ref([])
watchEffect(() => {
  let list = props.dataChart || []
  // let list = defaultD.prjValue || []
  earthData.value = list.map((item) => {
    let pos = [item[longitudeCode.value], item[latitudeCode.value]]
    console.log(pos)
    // let pos = [item['longitude'], item['latitude']]
    linesList.value.push([[116.475, 40.0109], [...pos]]);
    return {
      name: item[prjNameCode.value],
      value: [...pos],
      info: {
        chinesePersonnelNum: item[chineseCode.value],
        foreignNationalsNum: item[foreignCode.value],
      },
    }
  });
  console.log(earthData.value)
})

function videoOpen() {
  if (!props.option?.videoUrl) return;
// || (location.origin + "/visualization/surveillanceVideo/index?isNewWindow=true")
  window.open(props.option.videoUrl);
}

function checkMapState(states) {
  if (activeWordMap.value === states) return;
  activeWordMap.value = states;
  setTimeout(() => {
    updateChart()
    resize()
  }, 0);
}

// 中间地球
function earthEcharts() {
  loadingState.value = true
  echarts.init(earthRef.value).dispose();
  earthChart = echarts.init(earthRef.value);
  earthChart.setOption({
    globe: {
      baseTexture: bg1,
      heightTexture: bg2,
      displacementScale: 0.01,
      shading: "lambert",
      realisticMaterial: {
        metalness: 0.2, // 设置金属感
        roughness: 0.2, // 设置粗糙度
        reflectivity: 1, // 设置反射率
      },
      atmosphere: {
        show: true,
        color: "#377abd",
        thickness: 0.3,
        quality: 0.1,
      },
      postEffect: {
        // 后期特效
        enable: false,
        SSAO: {
          enable: true,
          radius: 2,
          intensity: 1.5,
        },
        depthOfField: {
          enable: false,
          focalDistance: 1000,
          fstop: 1.8,
          blurRadius: 1,
        },
        bloom: {
          enable: false,
          threshold: 1,
          blurSize: 1,
          blurAmount: 0,
          bloomStrength: 3,
          bloomRadius: 0,
        },
      },
      light: {
        main: {
          intensity: 0.3,
          shadow: true,
          quality: "high",
        },
        ambient: {
          intensity: 0.8,
        },
      },
      viewControl: {
        autoRotate: true,
        alpha: 20,
        beta: -5,
        distance: 250,
        autoRotateStart: [113.27, 23.13],
      },
    },
  });
  let dom = document.getElementById("earthMap")
  useEventListener(dom, "mouseenter", (e) => {
    earthChart.setOption({
      globe: {
        viewControl: {
          autoRotate: false, // 鼠标悬浮时停止旋转
        },
      },
    });
  });
  useEventListener(dom, "mouseleave", (e) => {
    earthChart.setOption({
      globe: {
        viewControl: {
          autoRotate: true, // 鼠标离开时恢复旋转
        },
      },
    });
  });
  // 地点信息
  earthChart.setOption({
    tooltip: {
      trigger: "item",
      formatter(params) {
        let content = "项目名称<br>" + params.data.name; // 可以根据data里的属性定制内容
        if (params.data.info) {
          // 假设数据中还有其他属性info
          content +=
              "<br>中方人数:    " +
              params.data.info.chinesePersonnelNum +
              "<br>外籍人数:    " +
              params.data.info.foreignNationalsNum;
        }
        return content;
      },
      position: "top",
      // 颜色
      backgroundColor: "rgba(8, 66, 165, 0.8)",
      padding: 10, // 上右下左的内边距分别为 10px
      borderWidth: 1, // 边框宽度为 1 像素
      borderColor: "#34a0e9", // 边框颜色为白色
      textStyle: {
        color: "#fff", // 文本颜色为白色
        fontSize: 12, // 文本字体大小为 12 像素
      },
    },
    series: [
      {
        type: "scatter3D",
        coordinateSystem: "globe", // 'globe'：地球坐标系
        showEffectOn: "render", // 'render'：在渲染完成后显示特效。'emphasis'：在鼠标悬停时显示特效。'none'：不显示特效。
        itemStyle: {
          color: "red",
          opacity: 1,
          // borderColor: "red",
          // borderWidth: 2,
          // shadowColor: "red",
          // shadowBlur: 10
        },
        // symbol: 'circle',
        hoverAnimation: false,
        symbolSize: (window.innerWidth / 100) * 0.3,
        data: earthData.value.map(function (d) {
          return {
            name: d.name,
            value: [d.value[0], d.value[1], 0],
            label: {
              show: false, // 默认不显示标签
              emphasis: {
                // 高亮状态的样式定义
                formatter: function (params) {
                  // 根据需要展示的内容定制
                  let content = "项目名称\n\n" + params.data.name; // 可以根据data里的属性定制内容
                  if (params.data.info) {
                    // 假设数据中还有其他属性info
                    content +=
                        "\n\n中方人数:    " +
                        params.data.info.chinesePersonnelNum +
                        "\n\n外籍人数:    " +
                        params.data.info.foreignNationalsNum;
                  }
                  return content;
                },
                position: "top",
                show: false, // 鼠标悬浮时显示
                color: "#fff",
                backgroundColor: "rgba(8, 66, 165, 0.8)",
                padding: 10, // 上右下左的内边距分别为 10px
                borderWidth: 1, // 边框宽度为 1 像素
                borderColor: "#34a0e9", // 红色边框
                borderRadius: 5,
              },
              extraCssText: "z-index: 2;", // 确保标签在其他元素之上
            },
            // 假设除了name之外，我们还想显示其他信息，比如info
            info: d.info, // 自定义的额外信息
          };
        }),
        blendMode: "lighter",
      },
      {
        type: "lines3D",
        coordinateSystem: "globe",
        data: linesList.value,
        // lineStyle: {
        //     normal: {
        //         // type: 'dotted', // 把实现变成虚线
        //         // color: '#586fb5', //连接线颜色
        //         width: 1.5,//线条宽度
        //         opacity: 0.8,
        //         curveness: 0.3,//线条弧度 0-1
        //     }
        // },
        blendMode: "lighter",
        effect: {
          show: true,
        },
        silent: false,
      },
    ],
  });
  setTimeout(() => {
    loadingState.value = false
    resize()
  }, 200)
}

// 世界地图
function wordEcharts() {
  loadingState.value = true
  echarts.init(wordRef.value).dispose();
  let myChart = echarts.init(wordRef.value);
  let option = {
    geo: {
      map: "world",
      label: {
        emphasis: {
          show: true,
          color: "#fff",
        },
      },
      roam: true,
      itemStyle: {
        normal: {
          areaColor: "rgba(0, 26, 45, 0)",
          borderColor: "#9ac5f0",
          borderWidth: 1.5,
          shadowColor: "#3697AD",
          shadowBlur: 30,
        },
        emphasis: {
          areaColor: "rgba(0, 26, 45, 0)",
        },
      },
      zoom: 0.8,
      regions: regions.value,
    },
    series: [
      {
        type: "effectScatter",
        coordinateSystem: "geo",
        zlevel: 2,
        symbolSize: [(window.innerWidth / 100) * 0.6, (window.innerWidth / 100) * 0.2],
        rippleEffect: {
          brushType: "stroke",
          scale: 5,
          period: 8,
        },
        itemStyle: {
          normal: {
            color: "#44FCF7",
          },
        },
        data: earthData.value.map(function (d) {
          return {
            name: d.name,
            value: [d.value[0], d.value[1], 0],
            label: {
              show: false, // 默认不显示标签
              emphasis: {
                // 高亮状态的样式定义
                formatter: function (params) {
                  // 根据需要展示的内容定制
                  let content = "项目名称\n\n" + params.data.name; // 可以根据data里的属性定制内容
                  if (params.data.info) {
                    // 假设数据中还有其他属性info
                    content +=
                        "\n\n中方人数:    " +
                        params.data.info.chinesePersonnelNum +
                        "\n\n外籍人数:    " +
                        params.data.info.foreignNationalsNum;
                  }
                  return content;
                },
                position: "top",
                align: "left",
                show: true, // 鼠标悬浮时显示
                color: "#fff",
                backgroundColor: "rgba(8, 66, 165, 0.8)",
                padding: 10, // 上右下左的内边距分别为 10px
                borderWidth: 1, // 边框宽度为 1 像素
                borderColor: "#34a0e9", // 红色边框
                borderRadius: 5,
              },
            },
            // 假设除了name之外，我们还想显示其他信息，比如info
            info: d.info, // 自定义的额外信息
          };
        }),
      },
    ],
  };
  myChart.resize();
  myChart.setOption(option);
  setTimeout(() => {
    loadingState.value = false
    resize()
  }, 200)
}

function init() {
  echarts.registerMap("world", wordData);
  useEventListener(window, "resize", useDebounceFn(() => {
    resize()
  }, 200));
  earthEcharts();
  rain();
  rain2();
  rain3();
}

// 背景雨
function rain() {
  var c = document.querySelector(".rain");
  var ctx = c.getContext("2d"); //获取canvas上下文
  var w = (c.width = document.querySelector(".rainBox").clientWidth);
  var h = (c.height = document.querySelector(".rainBox").clientHeight);

  //设置canvas宽、高

  function random(min, max) {
    return Math.random() * (max - min) + min;
  }

  function RainDrop() {
  }

  //雨滴对象 这是绘制雨滴动画的关键
  RainDrop.prototype = {
    init: function () {
      this.x = random(0, w); //雨滴的位置x
      this.y = h; //雨滴的位置y
      // this.color = 'hsl(180, 100%, 50%)';//雨滴颜色 长方形的填充色
      this.color = "hsl(180, 100%, 50%)"; //雨滴颜色 长方形的填充色
      this.vy = random(5, 0.2); //雨滴下落速度
      this.hit = 0; //下落的最大值
      this.size = 2; //长方形宽度
    },
    draw: function () {
      if (this.y > this.hit) {
        var linearGradient = ctx.createLinearGradient(this.x, this.y, this.x, this.y + this.size * 30);
        // 设置起始颜色
        linearGradient.addColorStop(0, "#34d4f1");
        // 设置终止颜色
        linearGradient.addColorStop(1, "#19498a");
        // 设置填充样式
        ctx.fillStyle = linearGradient;
        ctx.fillRect(this.x, this.y, this.size, this.size * 2); //绘制长方形，通过多次叠加长方形，形成雨滴下落效果
      }
      this.update(); //更新位置
    },
    update: function () {
      if (this.y > this.hit) {
        this.y -= this.vy; //未达到底部，增加雨滴y坐标
      } else {
        this.init();
      }
    },
  };

  function resize() {
    w = c.width = document.querySelector(".rainBox").clientWidth;
    h = c.height = document.querySelector(".rainBox").clientHeight;
  }

  //初始化一个雨滴

  var rs = [];
  for (var i = 0; i < 10; i++) {
    setTimeout(function () {
      var r = new RainDrop();
      r.init();
      rs.push(r);
    }, i * 300);
  }

  function anim() {
    ctx.clearRect(0, 0, w, h); //填充背景色，注意不要用clearRect，否则会清空前面的雨滴，导致不能产生叠加的效果
    for (var i = 0; i < rs.length; i++) {
      rs[i].draw(); //绘制雨滴
    }
    requestAnimationFrame(anim); //控制动画帧
  }

  useEventListener(window, "resize", useDebounceFn(() => {
    resize()
  }, 200));
  //启动动画
  anim();
}

function rain2() {
  var c = document.querySelector(".rain2");
  var ctx = c.getContext("2d"); //获取canvas上下文
  var w = (c.width = document.querySelector(".rainBox").clientWidth);
  var h = (c.height = document.querySelector(".rainBox").clientHeight);

  //设置canvas宽、高

  function random(min, max) {
    return Math.random() * (max - min) + min;
  }

  function RainDrop() {
  }

  //雨滴对象 这是绘制雨滴动画的关键
  RainDrop.prototype = {
    init: function () {
      this.x = random(0, w); //雨滴的位置x
      this.y = h; //雨滴的位置y
      // this.color = 'hsl(180, 100%, 50%)';//雨滴颜色 长方形的填充色
      this.color = "hsl(180, 100%, 50%)"; //雨滴颜色 长方形的填充色
      this.vy = random(5, 0.2); //雨滴下落速度
      this.hit = 0; //下落的最大值
      this.size = 2; //长方形宽度
    },
    draw: function () {
      if (this.y > this.hit) {
        var linearGradient = ctx.createLinearGradient(this.x, this.y, this.x, this.y + this.size * 30);
        // 设置起始颜色
        linearGradient.addColorStop(0, "#34d4f1");
        // 设置终止颜色
        linearGradient.addColorStop(1, "#19498a");
        // 设置填充样式
        ctx.fillStyle = linearGradient;
        ctx.fillRect(this.x, this.y, this.size, this.size * 2); //绘制长方形，通过多次叠加长方形，形成雨滴下落效果
      }
      this.update(); //更新位置
    },
    update: function () {
      if (this.y > this.hit) {
        this.y -= this.vy; //未达到底部，增加雨滴y坐标
      } else {
        this.init();
      }
    },
  };

  function resize() {
    w = c.width = document.querySelector(".rainBox").clientWidth;
    h = c.height = document.querySelector(".rainBox").clientHeight;
  }

  //初始化一个雨滴

  var rs = [];
  for (var i = 0; i < 10; i++) {
    setTimeout(function () {
      var r = new RainDrop();
      r.init();
      rs.push(r);
    }, i * 300);
  }

  function anim() {
    ctx.clearRect(0, 0, w, h); //填充背景色，注意不要用clearRect，否则会清空前面的雨滴，导致不能产生叠加的效果
    for (var i = 0; i < rs.length; i++) {
      rs[i].draw(); //绘制雨滴
    }
    requestAnimationFrame(anim); //控制动画帧
  }

  useEventListener(window, "resize", useDebounceFn(() => {
    resize()
  }, 200));
  //启动动画
  anim();
}

function rain3() {
  var c = document.querySelector(".rain3");
  var ctx = c.getContext("2d"); //获取canvas上下文
  var w = (c.width = document.querySelector(".rainBox").clientWidth);
  var h = (c.height = document.querySelector(".rainBox").clientHeight);

  //设置canvas宽、高

  function random(min, max) {
    return Math.random() * (max - min) + min;
  }

  function RainDrop() {
  }

  //雨滴对象 这是绘制雨滴动画的关键
  RainDrop.prototype = {
    init: function () {
      this.x = random(0, w); //雨滴的位置x
      this.y = h; //雨滴的位置y
      // this.color = 'hsl(180, 100%, 50%)';//雨滴颜色 长方形的填充色
      this.color = "hsl(180, 100%, 50%)"; //雨滴颜色 长方形的填充色
      this.vy = random(5, 0.2); //雨滴下落速度
      this.hit = 0; //下落的最大值
      this.size = 2; //长方形宽度
    },
    draw: function () {
      if (this.y > this.hit) {
        var linearGradient = ctx.createLinearGradient(this.x, this.y, this.x, this.y + this.size * 30);
        // 设置起始颜色
        linearGradient.addColorStop(0, "#34d4f1");
        // 设置终止颜色
        linearGradient.addColorStop(1, "#19498a");
        // 设置填充样式
        ctx.fillStyle = linearGradient;
        ctx.fillRect(this.x, this.y, this.size, this.size * 2); //绘制长方形，通过多次叠加长方形，形成雨滴下落效果
      }
      this.update(); //更新位置
    },
    update: function () {
      if (this.y > this.hit) {
        this.y -= this.vy; //未达到底部，增加雨滴y坐标
      } else {
        this.init();
      }
    },
  };

  function resize() {
    w = c.width = document.querySelector(".rainBox").clientWidth;
    h = c.height = document.querySelector(".rainBox").clientHeight;
  }

  //初始化一个雨滴

  var rs = [];
  for (var i = 0; i < 10; i++) {
    setTimeout(function () {
      var r = new RainDrop();
      r.init();
      rs.push(r);
    }, i * 300);
  }

  function anim() {
    ctx.clearRect(0, 0, w, h); //填充背景色，注意不要用clearRect，否则会清空前面的雨滴，导致不能产生叠加的效果
    for (var i = 0; i < rs.length; i++) {
      rs[i].draw(); //绘制雨滴
    }
    requestAnimationFrame(anim); //控制动画帧
  }

  useEventListener(window, "resize", useDebounceFn(() => {
    resize()
  }, 200));
  //启动动画
  anim();
}

function resize() {
  // 获取 ECharts 实例对象
  var earthMapChart = echarts.getInstanceByDom(earthRef.value);
  var wordMapChart = echarts.getInstanceByDom(wordRef.value);
  // 如果实例对象存在，则调用 resize 方法
  nextTick(() => {
    if (earthMapChart) {
      earthMapChart.resize();
    }
    if (wordMapChart) {
      wordMapChart.resize();
    } else {
      wordEcharts()
    }
  })
}

defineExpose({
  resize: resize,
  updateChart: updateChart
})
onMounted(() => {
  init()
})
</script>
<style lang="scss" scoped>
.earth-3d-container {
  width: 100%;
  height: 100%;
  position: relative;

  .earthMap {
    position: relative;
    z-index: 888;
    background-position: center;
    width: 100%;
    //height: 66%;
    height: 100%;
    //margin-bottom: 1.3889vh;

    > div {
      width: 100%;
      height: 100%;
    }
  }


  .videoOpen {
    font-weight: bold;
    text-align: center;
    line-height: 2.344vw;
    background-image: url("./assets/wordMap.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    width: 8.333vw !important;
    height: 2.344vw !important;
    color: #fff;
    font-size: 1.146vw;
    z-index: 9;
    cursor: pointer;
  }

  // 翻新样式

  .echartsModelS > .echartsModelS-title {
    cursor: pointer;
    background-image: url("./assets/title.png");
  }

  /* 世界地图地球切换 */

  .activeWordMap {
    width: 8.333vw;
    height: 2.344vw;
    background-image: url('./assets/activeWordMap.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    color: #fff;
    text-shadow: 0.156vw 0.156vw 0.156vw #11141638;
    font-size: 1.146vw;
    font-weight: bold;
    font-style: italic;
    text-align: center;
    line-height: 2.344vw;
    cursor: pointer;
  }

  .wordMap {
    width: 8.333vw;
    height: 2.344vw;
    background-image: url('./assets/wordMap.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    color: #fff;
    text-shadow: 0.156vw 0.156vw 0.156vw #11141638;
    font-size: 1.146vw;
    font-weight: bold;
    font-style: italic;
    text-align: center;
    line-height: 2.344vw;
    cursor: pointer;
  }

  .wordMapBox {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    justify-content: space-between;
    width: 20.833vw !important;
    height: 2.344vw !important;
    transform: translateX(-50%);
    z-index: 999;
  }

  .wordMapBox > div:first-child {
    background-image: url("./assets/3dmap.png");
    color: transparent;
  }

  .wordMapBox > div:last-child {
    background-image: url("./assets/wordMapNew.png");
    color: transparent;
  }

  .wordMapBox {
    left: 0 !important;
    bottom: 0 !important;
    display: flex !important;
    flex-direction: column;
    transform: translateX(0%);
    height: 4.688vw !important;
    width: 10vw !important;
  }

  .rainBox {
    position: absolute;
    width: 752px !important;
    height: 351px !important;
    transform: translateX(-50%);
    z-index: 1;
    left: 0;
    bottom: 0;

    canvas {
      position: absolute;
      bottom: 0;
    }
  }

  #earthMap,
  #wordMap {
    position: relative !important;
    //top: 4.208vw;
    //left: 0;
    z-index: 8 !important;
    //height: calc(100% - 4.208vw) !important;
    //padding-bottom: 15vh;
    //width: 100vw;
  }

  .activeWordMap {
    background-image: none;
  }

  .earthMapBtn-container {
    position: absolute;
    left: 0;
    bottom: 0;
    width: fit-content;
    height: fit-content;
    z-index: 999;
  }
}
</style>
<style lang="scss">
//#earthMap,
//#wordMap {
//  position: fixed !important;
//  top: 4.208vw;
//  left: 0;
//  z-index: 0 !important;
//  height: calc(100% - 4.208vw) !important;
//  padding-bottom: 15vh;
//  width: 100vw;
//}
</style>